import script from "./RegisterPaymentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterPaymentModal.vue?vue&type=script&setup=true&lang=js"

import "./RegisterPaymentModal.vue?vue&type=style&index=0&id=0eb5da2f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eb5da2f"]])

export default __exports__